module.exports = __webpack_public_path__ + "img/微课03.726ea998.svg";